import { jsx as s } from "react/jsx-runtime";
import { c as y } from "../../../index-Cu0xwYjD.js";
import { Children as m } from "react";
import { useResponsiveStyle as h } from "../../hooks/use-responsive-style.js";
import '../../../assets/Stack.css';const k = "_stack_106gu_4", z = "_vertical_106gu_10", x = "_horizontal_106gu_14", d = {
  stack: k,
  vertical: z,
  horizontal: x
}, V = ({
  children: l,
  className: u,
  spaceBetween: p = 4,
  orientation: e = "vertical"
}) => {
  if (!l)
    return null;
  const g = m.toArray(l).filter(Boolean), f = (t) => `var(--space-${t * 100})`, a = "margin-top", n = h(
    a,
    p,
    f
  ), [v, o, i, c] = n, r = n.slice(-1)[0];
  return /* @__PURE__ */ s("div", { className: u, children: /* @__PURE__ */ s(
    "div",
    {
      className: y(d.stack, {
        [d[e]]: e
      }),
      style: {
        "--margin-default": v[a],
        "--margin-small-and-up": (o && o[a]) ?? r[a],
        "--margin-medium-and-up": (i && i[a]) ?? r[a],
        "--margin-large-and-up": (c && c[a]) ?? r[a]
      },
      children: m.map(g, (t, _) => /* @__PURE__ */ s("div", { children: t }, _))
    }
  ) });
};
export {
  V as Stack
};
